import { useViewport } from "Hooks/useViewPort";

const MOBILE_BREAKPOINT = 1024;

export const useIsMobileCustomerPortal = () => {
  const { width } = useViewport();

  return {
    isMobileDevice: width < MOBILE_BREAKPOINT,
  };
};
